import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import BottomNav from "./BottomNav";
import AdBanner from "../AdBanner/AdBanner";
import "./Layout.css";

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Header />
      <AdBanner />
      <div className="layout-content">
        <Sidebar />
        {children}
      </div>
      <Footer />
      <BottomNav />
    </div>
  );
};

export default Layout;
